<template>
    <div v-if="discount[price.baseRateKey]" class="v-application">
        <span
            class="mr-2 font-weight-medium"
            :class="labelColors"
        >
            {{ price.label }}:
        </span>
        <span class="d-flex font-weight-bold">
            <span>{{ discount[price.baseRateKey] }}</span>
            <span class="mx-1">/</span>
            <span>{{ discount[price.marginKey] || '-' }}</span>
        </span>
    </div>
</template>
<script>
    export default {
        props: {
            price: Object,
            discount: Object
        },
        computed: {
            labelColors() {
                return {
                    'blue--text': this.price.label.toLowerCase() === 'apotheker',
                    'orange--text text--darken-2': this.price.label.toLowerCase() === 'pta',
                    'green--text text--darken-2': this.price.label.toLowerCase() === 'pka',
                }
            }
        },
    }
</script>
<style scoped>
.v-application {
    justify-content: center;
}
</style>
